
import React from 'react';

const ChallengeVideo = ({ video, classes }) => {
  if (!video) return null;

  return (
    <div className={classes.ideaDescriptionVideo}>
      <p className={classes.header}>Video</p>
      <iframe
        className={classes.iframe}
        title="ytVideo"
        width="540"
        height="320"
        src={video}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default ChallengeVideo;
